import { gql } from "@apollo/client";
import { RealtimeSettlementOrderDailySumType } from "../types/RealtimeSettlementOrderDailySumType";

export const FIELDS = `
    id
    clientId
    clientName
    orderCount
    dailyDate
    currency
    sumAmount
`;

export const GET_REALTIME_SETTLEMENT_ORDER_DAILY_SUM_LISTING = gql`
    query RealtimeSettlementOrderDailySumQuery($filters: RealtimeSettlementOrderDailySumFilterTypeInput,
                       $pageRequest: PageRequestTypeInput) {
        getRealtimeSettlementOrderDailySumPageable(filters: $filters, pageRequest: $pageRequest) {
            content{
                ${FIELDS}
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface RealtimeSettlementOrderDailySumListResponse {
    getRealtimeSettlementOrderDailySumPageable: RealtimeSettlementOrderDailySumResponseType;
}

export interface RealtimeSettlementOrderDailySumResponseType {
    content: RealtimeSettlementOrderDailySumType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

interface PageRequestType {
    page: number;
    size: number;
    sortBy: string;
    sortDirection: string;
}
